import React, { useEffect, useRef, useState } from "react";

import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import Headers from "./frame/headers.component";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import AuthService from "../services/auth.service";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import moment from "moment";
import dayjs from "dayjs";
import { ConsoleSqlOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";

interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;

}

interface WaitListView {
  selectedClubInfo: ClubInfo | null;
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}
const WaitListView: React.FC<WaitListView> = ({ selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [token, settoken] = useState<string | null>(null);
  const [agentsettingalldata, setagentsettingalldata] = useState<any>([]);
  const [firstElement, setfirstElement] = useState("");
  const [secondElement, setsecondElement] = useState("");
  const [thirdElement, setthirdElement] = useState("");
  const [fourthElement, setfourthElement] = useState("");
  const [newwaitname, setnewwaitname] = useState("");
  const [tableData, setTableData] = useState<any[]>([]);
  const [receiptcount, setreceiptcount] = useState<number>(0);
  const [newwaitlocalname, setnewwaitlocalname] = useState("");
  const [selecteagentSetting, setselecteagentSetting] = useState<any[]>([]);
  const [isreceptionRotating, setIsreceptionRotating] = useState(false);
  const [receptionmodalOpen, setreceptionModalOpen] = useState(false);
  const [receptionselecteagentSetting, setreceptionselecteagentSetting] = useState<any[]>([]);
  const [isreceptionModallocalname_emp, setisreceptionModallocalname_emp] = useState(false);
  const [receptiondata, setreceptiondata] = useState<any[]>([]);
  const [waitingdata, setwaitingdata] = useState<any[]>([]);
  const [waitingdata1, setwaitingdata1] = useState<any[]>([]);
  const [receptionselectedDeviceName, setreceptionSelectedDeviceName] = useState<string>("");
  const [agentsettingdeviceName, setagentsettingdeviceName] = useState<any>([]);
  const { TextArea } = Input;

  const fetchreceptionlistDataAPI = async () => {
    if(receptionselectedDeviceName!==""){
      const currentDate = new Date();
      const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
      const correctedDate = new Date(currentDate.getTime() - localOffset);
  
      const formattedDate = correctedDate.toISOString().split("T")[0];
      console.log(`${API_BASE_URL}/club/agent/waiting/list/department/${selectedClubInfo?.club_seq}/${formattedDate}/${receptionselectedDeviceName}?page=0&size=1000&sort=agentClubWaitingSeq,desc`)
      fetch(
        `${API_BASE_URL}/club/agent/waiting/list/department/${selectedClubInfo?.club_seq}/${formattedDate}/${receptionselectedDeviceName}?page=0&size=1000&sort=agentClubWaitingSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("접수 로우 리스트 : " + JSON.stringify(data.data.content, null, 2))
          const extractedData = data.data.content
            .map((item: any, index: any, array: any) => {
              const invitationEmptyLocalNameValid = item.invitationEmptyLocalNameValid;
              const invitationClubValid = item.invitationClubValid;
              let membername = null;
              let memberlocalname = null;
              let membermobilenumber = null;
  
  
              if (invitationEmptyLocalNameValid === false) {
                membername = item.memberName;
                if (invitationClubValid === false) {
                  memberlocalname = item.localName;
                  membermobilenumber = item.mobileNumber;
                } else {
                  memberlocalname = item.invitationLocalName;
                  membermobilenumber = item.invitationMobileNumber;
                }
  
              } else {
                membername = item.invitationName;
                memberlocalname = item.invitationLocalName;
                membermobilenumber = item.invitationMobileNumber;
              }
  
              let symptomsWithoutBrackets;
              let symptomsBrackets;
              let roomWithoutBrackets;
              console.log("item.questionnaire :" + item.questionnaire)
              if (item.questionnaire !== null) {
                symptomsWithoutBrackets = item.questionnaire.replace(/\[/g, "").replace(/\]/g, "");
  
                symptomsBrackets = symptomsWithoutBrackets.split("#")[0].replace(/,/g, "");
                roomWithoutBrackets = symptomsWithoutBrackets.split("#")[1].split("@")[0].replace(/,/g, "");
              }
              return {
                대기번호: array.length - index || null,
                회원명: membername || null,
                전화번호: membermobilenumber || null,
                내원증상: symptomsBrackets || "",
                진료실: roomWithoutBrackets ? roomWithoutBrackets : "",
                가족: item.extraData ? JSON.parse(item.extraData).가족 : null,
                차트번호: memberlocalname || null,
                메모: "" ? "" : null,
                created: item.created
              };
            })
            .sort((a: any, b: any) => a.created - b.created);
          console.log("대기값 : " + JSON.stringify(extractedData));
  
  
          console.log("접수 리스트 : " + JSON.stringify(extractedData, null, 2))
          setreceptiondata(extractedData);
          setreceiptcount(tableData.length);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

  };

  const fetchreceptionagentSettingDataAPI = async () => {
    if (token !== null && selectedClubInfo?.club_seq !== undefined && selectedClubInfo?.club_seq !== 0) {
      try {
        console.log(`${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`)
        const response = await fetch(
          `${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`,
          {
            method: "GET",

            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        const agentSettingList = data.data.agentSettingList;


        const deviceNames = agentSettingList.map((agentSetting: any) => agentSetting.deviceName);

        // console.log("agentsetting 총 값 :" + JSON.stringify(agentSettingList, null, 2))
        console.log("deviceNames 값 :" + JSON.stringify(deviceNames, null, 2))
        setreceptionselecteagentSetting(deviceNames)
        // console.log("select에 넣을 데이터 : " + deviceNames)



        let selectvalue = "";
        // if (selectedDeviceNameRef.current === "") {
        //   console.log("처음")
        //   console.log("첫번째값 : " + deviceNames[0])
        //   selectvalue = deviceNames[0];
        //   console.log("Selected value:  ", selectvalue);
        //   setreceptionSelectedDeviceName(selectvalue);
        //   // setagentsettingdeviceName(deviceNames);
        // } else {
        //   console.log("처음아님")
        //   selectvalue = receptionselectedDeviceName;
        //   console.log("Selected value:  ", selectvalue);
        //   console.log("진료과변경")
        //   console.log("(ExcelUpload) 지금 선택중인 진료과 : " + selectvalue)
        //   onselectedDeviceNameChange1(selectvalue);
        //   console.log("여기2")
        //   fetchreceptionlistDataAPI();
        // }

        console.log("선택한 최종값 : " + selectvalue)



        const filteredData = agentSettingList.filter((item: any) => item.deviceName === selectvalue);
        setagentsettingalldata([agentSettingList])
        setselecteagentSetting(filteredData);

        console.log("현재 receptionselectedDeviceName " + selectvalue)

      } catch (error) {
        console.error("(ExcelUpload) Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if(token!==null){
      fetchreceptionagentSettingDataAPI();
      fetchreceptionlistDataAPI();
    }
    
  }, [token]);
  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);
  const receptiontoggleModal = () => {
    console.log("ㅎㅇ" + receptionmodalOpen)
    setreceptionModalOpen(!receptionmodalOpen);
  };
  const waitnamehandleInputChange = (e: any) => {
    setnewwaitname(e.target.value);
  };
  const waitlocalnamehandleInputChange = (e: any) => {
    setnewwaitlocalname(e.target.value);
  };
  //   useEffect(() => {
  //     if (token !== null) {
  //         console.log("소켓 실행");
  //         const socket = new SockJS(API_BASE_URL + "/ws");
  //         console.log("소켓 아이디 : " + selectmemberidsoket);
  //         const stomp = Stomp.over(socket);

  //         const headers = { 'sender': selectmemberidsoket, 'admin': 'true' };
  //         if (stomp && stomp.connected) { // stompClient가 존재하고 연결되어 있는지 확인
  //             console.log("WebSocket 연결이 해제되었습니다.");
  //             stomp.disconnect(() => {
  //                 console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
  //             });
  //         }
  //         stomp.connect(
  //             headers,
  //             function (frame) {
  //                 console.log("연결 성공");

  //                 stomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
  //                     try {
  //                         console.log("message: ", message);
  //                         if (token !== null) {
  //                             console.log("리프레시 실행");
  //                             fetchreceptionagentSettingDataAPI(); 
  //                             // receptionhandleRotate();

  //                         }
  //                     } catch (error) {
  //                         console.error("Error parsing message:", error);
  //                     }
  //                 });

  //                 setStompClient(stomp); 
  //             },
  //             (error) => {
  //                 console.error("Error during WebSocket connection:", error);
  //             }
  //         );
  //         // 소켓 연결이 끊어졌을 때 재연결을 시도합니다.
  //         stomp.ws.onclose = () => {
  //             console.log("WebSocket 연결이 끊어졌습니다.");

  //                 const intervalId = setInterval(() => {
  //                     console.log("재연결을 시도합니다.");
  //                     const newSocket = new SockJS(API_BASE_URL + "/ws");
  //                     const newStomp = Stomp.over(newSocket);
  //                     newStomp.connect(headers, () => {
  //                         console.log("재연결 성공");
  //                         setStompClient(newStomp);
  //                         clearInterval(intervalId); 

  //                     });
  //                 }, 1000); // 5초마다 실행되도록 설정

  //                 // 컴포넌트가 언마운트될 때 setInterval 해제
  //                 return () => clearInterval(intervalId);
  //         };

  //         // WebSocket 연결 에러 처리
  //         stomp.ws.onerror = () => {
  //             console.log("WebSocket 연결 에러.");

  //             const intervalId = setInterval(() => {
  //                 console.log("재연결을 시도합니다.");
  //                 const newSocket = new SockJS(API_BASE_URL + "/ws");
  //                 const newStomp = Stomp.over(newSocket);
  //                 newStomp.connect(headers, () => {
  //                     console.log("재연결 성공");
  //                     setStompClient(newStomp);
  //                     clearInterval(intervalId); 

  //                 });
  //             }, 1000); // 5초마다 실행되도록 설정

  //             // 컴포넌트가 언마운트될 때 setInterval 해제
  //             return () => clearInterval(intervalId);
  //         };
  //     }

  //     return () => {
  //         // 컴포넌트 언마운트 시 소켓 연결 해제
  //         if (stompClient) {
  //             stompClient.disconnect(() => {
  //                 console.log("WebSocket 연결이 해제되었습니다.");
  //             });
  //         }
  //     };
  // }, [token]);

  // useEffect(() => {
  //   if (token !== null && selectmemberidsoket) {
  //     console.log("소켓 실행");

  //     const socket = new SockJS(API_BASE_URL + "/ws");
  //     console.log("소켓 아이디 : " + selectmemberidsoket);
  //     var stomp = Stomp.over(socket);

  //     const headers = { 'sender': selectmemberidsoket, 'type': 'waiting' };
  //     if (stomp && stomp.connected) { // stompClient가 존재하고 연결되어 있는지 확인
  //       console.log("WebSocket 연결이 해제되었습니다.");
  //       stomp.disconnect(() => {
  //         console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
  //       });
  //     }
  //     stomp.connect(
  //       headers,
  //       function (frame) {
  //         console.log("연결 성공");

  //         stomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
  //           try {
  //             console.log("message: ", message);
  //             if (token !== null) {
  //               console.log("리프레시 실행");
  //               console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
  //               fetchreceptionagentSettingDataAPI();
  //             }
  //           } catch (error) {
  //             console.error("Error parsing message:", error);
  //           }
  //         });

  //         setStompClient(stomp);
  //       },
  //       (error) => {
  //         console.error("Error during WebSocket connection:", error);
  //       }
  //     );
  //     // 소켓 연결이 끊어졌을 때 재연결을 시도합니다.
  //     stomp.ws.onclose = () => {
  //       console.log("WebSocket 연결이 끊어졌습니다.");
  //       setStompClient(null)
  //       // const intervalId = setInterval(() => {
  //       //   console.log("재연결을 시도합니다.");
  //       //   const newSocket = new SockJS(API_BASE_URL + "/ws");
  //       //   const newStomp = Stomp.over(newSocket);
  //       //   // newStomp.connect(headers, () => {
  //       //   //     console.log("재연결 성공");
  //       //   //     //setStompClient(stomp);
  //       //   //     clearInterval(intervalId); 

  //       //   // });

  //       //   newStomp.connect(
  //       //     headers,
  //       //     function (frame) {
  //       //       console.log("연결 성공");
  //       //       clearInterval(intervalId);
  //       //       newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
  //       //         try {
  //       //           console.log("message: ", message);
  //       //           if (token !== null) {
  //       //             console.log("리프레시 실행");
  //       //             console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
  //       //             fetchreceptionagentSettingDataAPI();
  //       //           }
  //       //         } catch (error) {
  //       //           console.error("Error parsing message:", error);
  //       //         }
  //       //       });

  //       //       setStompClient(stomp);
  //       //     },
  //       //     (error) => {
  //       //       console.error("Error during WebSocket connection:", error);
  //       //     }
  //       //   );

  //       //   newStomp.ws.onclose = () => {
  //       //     console.log("WebSocket 연결이 끊어졌습니다.");
  //       //     setStompClient(null)
  //       //   };
  //       //   newStomp.ws.onerror = () => {
  //       //     console.log("WebSocket 연결이 끊어졌습니다.");
  //       //     setStompClient(null)
  //       //   };


  //       // }, 1000); // 5초마다 실행되도록 설정

  //       // // 컴포넌트가 언마운트될 때 setInterval 해제
  //       // return () => clearInterval(intervalId);
  //     };

  //     // WebSocket 연결 에러 처리
  //     stomp.ws.onerror = () => {
  //       // console.log("WebSocket 연결 에러.");
  //       // setStompClient(null)
  //       // const intervalId = setInterval(() => {
  //       //   console.log("재연결을 시도합니다.");
  //       //   const newSocket = new SockJS(API_BASE_URL + "/ws");
  //       //   const newStomp = Stomp.over(newSocket);
  //       //   // newStomp.connect(headers, () => {
  //       //   //     console.log("재연결 성공");
  //       //   //     //setStompClient(stomp);
  //       //   //     clearInterval(intervalId); 

  //       //   // });

  //       //   newStomp.connect(
  //       //     headers,
  //       //     function (frame) {
  //       //       console.log("연결 성공");
  //       //       clearInterval(intervalId);
  //       //       newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
  //       //         try {
  //       //           console.log("message: ", message);
  //       //           if (token !== null) {
  //       //             console.log("리프레시 실행");
  //       //             console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
  //       //             fetchWaitinglistDataAPII();
  //       //           }
  //       //         } catch (error) {
  //       //           console.error("Error parsing message:", error);
  //       //         }
  //       //       });

  //       //       setStompClient(stomp);
  //       //     },
  //       //     (error) => {
  //       //       console.error("Error during WebSocket connection:", error);
  //       //     }
  //       //   );

  //       //   newStomp.ws.onclose = () => {
  //       //     console.log("WebSocket 연결이 끊어졌습니다.");
  //       //     setStompClient(null)
  //       //   };
  //       //   newStomp.ws.onerror = () => {
  //       //     console.log("WebSocket 연결이 끊어졌습니다.");
  //       //     setStompClient(null)
  //       //   };


  //       // }, 1000); // 5초마다 실행되도록 설정

  //       // // 컴포넌트가 언마운트될 때 setInterval 해제
  //       // return () => clearInterval(intervalId);
  //     };
  //   }

  //   return () => {
  //     // 컴포넌트 언마운트 시 소켓 연결 해제
  //     if (stompClient) {
  //       stompClient.disconnect(() => {
  //         console.log("WebSocket 연결이 해제되었습니다.");
  //       });
  //     }
  //   };
  // }, [token, selectmemberidsoket]);
  const receptionhandleConfirm = () => {
    // 대기 신규회원 정보 수정

    console.log("선택한 전화번호 :" + thirdElement)
    console.log("선택한 클럽  :" + selectedClubInfo?.club_seq)

    const patchData = {
      clubSeq: selectedClubInfo?.club_seq,
      mobileNumber: thirdElement,
      localName: newwaitlocalname,
      memberName: newwaitname

    };

    console.log("수정내용" + JSON.stringify(patchData, null, 2))
    console.log(`${API_BASE_URL_ISSUER}/invitations/localname/extradata`)
    fetch(`${API_BASE_URL_ISSUER}/invitations/localname/extradata`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(patchData),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        receptiontoggleModal();
      })
      .catch(error => {
        console.error('There was an error with the PATCH request:', error);
      });

  };

  const receptiontablehandleRowClick = (record: any) => {
    console.log("모달실행!" + JSON.stringify(record))
    // receptiontoggleModal();
    // setreceptionModalselectvalue(record)
    // console.log("Selected Row Values:", record);
    // setSelectedRowKey(record.key === selectedRowKey ? null : record.key);
    const firstElement = record.대기번호; // First element
    const secondElement = record.회원명; // Second element
    const thirdElement = record.전화번호; // Third element
    const fourthElement = record.차트번호; // Third element

    setfirstElement(firstElement || "대기번호");
    setsecondElement(secondElement || "회원명");
    setthirdElement(thirdElement || "휴대번호");
    setfourthElement(fourthElement || "차트번호");
  };
  const receptioncolumns = [
    {
      title: "순번",
      dataIndex: "대기번호",
      key: "대기번호",
      align: "center",
      ellipsis: true,
    },
    {
      title: "회원명",
      dataIndex: "회원명",
      key: "회원명",
      ellipsis: true,
      align: "center",
    },
    {
      title: "전화번호",
      dataIndex: "전화번호",
      key: "전화번호",
      ellipsis: true,
      align: "center",
    },
    {
      title: "내원증상",
      dataIndex: "내원증상",
      key: "내원증상",
      ellipsis: true,
      align: "center",
    },
    {
      title: "진료실",
      dataIndex: "진료실",
      key: "진료실",
      ellipsis: true,
      align: "center",
    },
    {
      title: "가족",
      dataIndex: "가족",
      key: "가족",
      width: 200,
      render: (text: any) => (
        <div style={{ whiteSpace: "pre-line" }}>{text}</div>
      ),
    },
    {
      title: "아이디",
      dataIndex: "차트번호",
      key: "차트번호",
      align: "center",
    },
    {
      title: "메모",
      dataIndex: "메모",
      key: "메모",
      width: "10%",
      titleStyle: { backgroundColor: "#FAFAFA" },
      render: (text: string, record: any) => (
        <div>
          <TextArea />
        </div>
      ),
    },
  ];

  const receptionhandleAgentSettingChange = (event: React.ChangeEvent<HTMLSelectElement>) => {

    setwaitingdata([]);
    setwaitingdata1([]);
    console.log("진료과선택!");
    const selectedValue = event.target.value;
    console.log("선택한 진료과 :", selectedValue);


    console.log("전체agentsetting 데이터  : " + JSON.stringify(agentsettingalldata, null, 2))



    const filterDataByDeviceName = (data: any, selectedValue: any) => {
      const filteredData = [];

      for (const list of data) {
        for (const item of list) {
          if (item.deviceName === selectedValue) {
            filteredData.push(item);
          }
        }
      }

      return filteredData;
    };

    const filteredData = filterDataByDeviceName(agentsettingalldata, selectedValue);




    setselecteagentSetting(filteredData);


    console.log("setreceptionSelectedDeviceName 업데이트 : " + selectedValue)
    setreceptionSelectedDeviceName(selectedValue);

    fetchreceptionlistDataAPI();


  };
  const receptionhandleRotate = () => {
    console.log("접수 새로고침 클릭!")
    setIsreceptionRotating(true);
    setwaitingdata([]);
    setwaitingdata1([]);
    console.log("진료과선택!");
    console.log("선택값 : " + receptionselectedDeviceName)
    const selectedValue = receptionselectedDeviceName;
    console.log("선택한 진료과 :", selectedValue);


    // console.log("전체agentsetting 데이터  : " + JSON.stringify(agentsettingalldata, null, 2))



    const filterDataByDeviceName = (data: any, selectedValue: any) => {
      const filteredData = [];
      for (const list of data) {
        for (const item of list) {
          if (item.deviceName === selectedValue) {
            filteredData.push(item);
          }
        }
      }
      return filteredData;
    };

    const filteredData = filterDataByDeviceName(agentsettingalldata, selectedValue);


    setselecteagentSetting(filteredData);


    console.log("setreceptionSelectedDeviceName 업데이트 : " + selectedValue)

    // fetchWaitinglistDataAPII();


    setTimeout(() => setIsreceptionRotating(false), 500); // 3초 후에 회전을 멈춥니다.
  };
  return (

    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px" }}>
      <>
        <div style={{ fontSize: "24px" }}>
          | { } 접수
        </div>


      </>
      <div
        style={{
          textAlign: "left",
          fontSize: "30px",
        }}
      >
        접수명단
        <select
          value={receptionselectedDeviceName} // 선택된 옵션의 값을 여기에 설정
          onChange={receptionhandleAgentSettingChange} // 옵션을 선택할 때 호출될 이벤트 핸들러
          style={{
            border: "none",
            borderRadius: "5px",
            backgroundColor: "rgba(255, 255, 255, 0)",
            fontSize: "30px",
            cursor: "pointer",
            outline: "none",
            width: "200px",
            height: "50px",
            marginLeft:"100px"
          }}
        >
          {receptionselecteagentSetting.map((deviceName: string, index: number) => (
            <option key={index} value={deviceName}>{deviceName}</option>
          ))}
        </select>

        <img
          src="asset/img/refresh.png"
          alt="Refresh Icon"
          onClick={receptionhandleRotate}
          className={isreceptionRotating ? "rotate" : ""}
          style={{
            width: "50px",
            height: "50px",
            cursor: "pointer",
            marginLeft: "1000px",
            transition: "transform 1s linear",
            transform: isreceptionRotating ? "rotate(1500deg)" : "rotate(0deg)"

          }}
        />



      </div>

      <div
        style={{
          width: "100%",
          height: width <= 1600 ? "500px" : "700px",
          marginTop: "30px",
          overflowY: "auto",
          scrollbarColor: "gray lightgray"
        }}
      >

        {receptionmodalOpen && isreceptionModallocalname_emp && (

          <Modal
            title="신규 회원 정보 수정"
            style={{ fontSize: "18px", borderRadius: "20px" }}
            open={receptionmodalOpen}

            // onCancel={() => setWaitIsModalVisible(false)}
            onCancel={receptiontoggleModal}
            width={600}
            footer={[
              <div key="button-container" style={{ textAlign: "center" }}>
                <Button
                  key="confirm"
                  type="primary"
                  onClick={receptionhandleConfirm}
                  style={{
                    width: "220px",
                    height: "56px",
                    borderRadius: "20px",
                    color: "#fff",
                    background: "#2D5478",
                    borderColor: "#2D5478",
                  }}
                >
                  저장
                </Button>
              </div>
            ]}
          >
            <div style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", marginBottom: "8px" }}>
                <div style={{ marginRight: "8px", width: "300px" }}>이름</div>
                <div style={{ marginRight: "8px", width: "300px" }}>차트번호</div>
              </div>

              <div style={{ display: "flex", marginBottom: "8px" }}>

                <Input
                  placeholder="이름"
                  // value={info.name}
                  onChange={waitnamehandleInputChange}

                  style={{ marginRight: "8px", width: "300px" }}
                />
                <Input
                  placeholder="차트번호"
                  // value={info.chartNumber}
                  onChange={waitlocalnamehandleInputChange}
                  style={{ marginRight: "8px", width: "300px" }}
                />
              </div>
            </div>
          </Modal>

        )}
        <table style={{ borderCollapse: 'collapse', width: '50%' }}>
          <thead>

            <tr>

              {receptioncolumns.map((col, index) => (
                <th key={col.key} style={{ textAlign: 'center', border: '1px solid black', width: col.width }}>{col.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {receptiondata.map((record, index) => (
              <tr
                key={record.key}
                style={{ border: '1px solid black' }}
                onClick={() => receptiontablehandleRowClick(record)}
              >
                {receptioncolumns.map((col) => (
                  <td key={col.key} style={{ textAlign: 'center', border: '1px solid black' }}>
                    {col.dataIndex === '진료실' ? (
                      <div>
                        <div>{record[col.dataIndex]}</div>
                      </div>
                    ) : col.dataIndex === '메모' ? (
                      <textarea
                        style={{ width: '100%' }}
                        defaultValue={record[col.dataIndex]}
                      />
                    ) : col.dataIndex === '가족' ? (
                      <div>
                        {record[col.dataIndex] && record[col.dataIndex].map((familyMember: any, index: any) => (
                          <div key={index}>
                            {Object.entries(familyMember).map(([key, value]) => {
                              if (key === '이름' && value) {
                                const gender = familyMember['성별'] === '남' ? 'M' : 'F';
                                const birthDate = familyMember['생년월일'];
                                const relationship = familyMember['관계'];
                                const age = new Date().getFullYear() - new Date(birthDate).getFullYear();
                                return (
                                  <div key={key}>{`${relationship} ${value} ${gender}/${age}`}</div>
                                );
                              }
                              return null;
                            })}
                          </div>
                        ))}
                      </div>
                    ) : (
                      record[col.dataIndex]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>

  );

};

export default WaitListView;
